// extracted by mini-css-extract-plugin
var _1 = "AudioPreview-moduleFilePreviewAudio__eh6Xg";
export { _1 as "FilePreviewAudio" }
